declare global {
  interface Window {
    ym: any;
    dentolo_quiz_ec: any[];
  }
}

export class YaMetrikaCounter {
  private ym: any;

  public init(counter: number, domain: string) {
    const SRC = "https://mc.yandex.ru/metrika/tag.js";
    const $this = this;

    this.ym = window.ym || function () {
      $this.ym.a = $this.ym.a || [];
      $this.ym.a.push(arguments);
    };

    this.ym.l = new Date().getTime();
    window.ym = this.ym;

    const isAlreadyExist = document.querySelector(`[src="${SRC}"]`);

    if (!isAlreadyExist) {
      const script = document.createElement("script");
      const firstScript = document.getElementsByTagName("script")[0];
      script.async = true;
      script.src = SRC;
      firstScript?.parentNode?.insertBefore(script, firstScript);
    }

    window.ym(counter, "init", {
      trustedDomains: [domain],
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
      trackHash:true
    });
  }
}
